// extracted by mini-css-extract-plugin
export default {"viewBox":"game_viewBox__S3oDq","teamName":"game_teamName__wW0PS","newRow":"game_newRow__HPcy8","vs":"game_vs__a+Y4x"};